import { SlsInventoryCenter } from '@/services/inventory/slsInventoryStatus/types'

/** `interface` 가 아니라 `type` 인 것은 의도다 — pbo-core `Table` 의 `dataSource: Record<string, unknown>[]` 에
 *  인터페이스는 암묵적 인덱스 시그니처가 없어 그대로 못 넘긴다. */
export type SlsInventoryTableRow = {
  whNm: string
  locationCode: string
  shipperCode: string
  barcode: string
  totalQty: number
  allocationQty: number
  remainingQty: number
  unavailableQty?: number
}

// 비가용만 있는 행(가용 0, 비가용 3)도 남겨야 한다 — 비가용 컬럼을 보러 오는 화면이라 걸러내면 조회 목적이 사라진다.
const isAllZero = (row: Pick<SlsInventoryTableRow, 'totalQty' | 'allocationQty' | 'remainingQty' | 'unavailableQty'>) =>
  row.totalQty === 0 && row.allocationQty === 0 && row.remainingQty === 0 && !row.unavailableQty

/**
 * 센터별 응답을 표 행으로 편다. 수량이 전부 0 인 행(SLS 응답이 빈 센터 포함)은 걸러낸다 —
 * 재고가 실제로 있는 센터만 보고 싶다는 요청(LOGISPRD-12297)에 따른 것.
 */
export const toSlsInventoryTableRows = (centers: SlsInventoryCenter[]): SlsInventoryTableRow[] =>
  centers
    .flatMap((center) => center.rows.map((row) => ({ whNm: center.whNm ?? center.locationCode, locationCode: center.locationCode, ...row })))
    .filter((row) => !isAllZero(row))

/** 표에 뿌린 행 전체 합계. 응답에 전 행이 다 오고 페이징도 없어 BE 합계 없이 FE 에서 더한다(LOGISPRD-12302). */
export const sumSlsInventoryRows = (rows: SlsInventoryTableRow[]) =>
  rows.reduce(
    (acc, row) => ({
      totalQty: acc.totalQty + row.totalQty,
      allocationQty: acc.allocationQty + row.allocationQty,
      remainingQty: acc.remainingQty + row.remainingQty,
      // 구버전 BE 응답에는 unavailableQty 가 없다.
      unavailableQty: acc.unavailableQty + (row.unavailableQty ?? 0),
    }),
    { totalQty: 0, allocationQty: 0, remainingQty: 0, unavailableQty: 0 },
  )
